"use strict";
export const PROTOCOL_LEGEND_ELEMENT_ID = "protocolGraphLegend";
